import { createContext, useState } from "react"

export const DataContext = createContext();

export const DataProvider = ({ children }) => {

    const [identifiantCR, setIdentifiantCR] = useState(null)
    const [dataAPI, setDataAPI] = useState(null)
    const [isLoaded, setIsLoaded] = useState(false)

    const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzUxMiIsImtpZCI6IjI4YTMxOGY3LTAwMDAtYTFlYi03ZmExLTJjNzQzM2M2Y2NhNSJ9.eyJpc3MiOiJzdXBlcmNlbGwiLCJhdWQiOiJzdXBlcmNlbGw6Z2FtZWFwaSIsImp0aSI6ImY5ZGI3OGFlLTY4M2MtNDAyYS1iNTAwLTU2MzhhZGEzMDM1ZiIsImlhdCI6MTY0NDMzMTUxNywic3ViIjoiZGV2ZWxvcGVyLzZjY2I3ODY4LWIwOTEtZDM5OC04ZWNjLTBkMDlmZWRhZjkwMiIsInNjb3BlcyI6WyJyb3lhbGUiXSwibGltaXRzIjpbeyJ0aWVyIjoiZGV2ZWxvcGVyL3NpbHZlciIsInR5cGUiOiJ0aHJvdHRsaW5nIn0seyJjaWRycyI6WyI0NS43OS4yMTguNzkiXSwidHlwZSI6ImNsaWVudCJ9XX0.h8jtFsAF3wDkYVB8wvqSr29AUDPjXBkbpU8t7_la2uevWSnZKPTxEr_N201llIAmKjuzRr2iyE1oo3EWCVDWdw';
 
    return (
        <DataContext.Provider value={{ token, dataAPI, setDataAPI, isLoaded, setIsLoaded, identifiantCR, setIdentifiantCR }}>
            {children}
        </DataContext.Provider>
    )
}